import { defineMessages } from "react-intl";

export const messages = defineMessages({
  startBookable: {
    id: "default.startDate",
    description: "Start date",
    defaultMessage: "Start Date",
  },
  endBookable: {
    id: "default.endDate",
    description: "End date",
    defaultMessage: "End Date",
  },
  endDateAfterStart: {
    id: "app.periodConditions.endDateAfterStart",
    description: "The end date must be greater than the start date and greater than today",
    defaultMessage: "The end date must be greater than the start date and greater than today",
  },
});
